import { List, Dialog, Modal, Toast, Tabs } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Form, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import PsContext from "../../context";
import {
  groupByMultiple,
  lowerCase,
  momentDate,
  queryParam,
  upperCase,
  useQuery,
  yearByBatch,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";

import ButtonScreen from "./buttonScreen";
import AttendanceType from "./attendanceType";
import SwipeScreen from "./swipeScreen";
import MarkedHostelAttendanceReport from "../markedHostelAttendanceReport";

const HostelAttendance = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [longAbsentee, setLongAbsentee] = useState([]);

  const [markedData, setMarkedData] = useState([]);

  const [markedStudents, setMarkedStudents] = useState([]);
  const [workDone, setWorkDone] = useState(null);
  const workDoneRef = useRef(null);
  const [timeSlots, setTimeSlots] = useState([]);
  const [allowAttendance, setAllowAttendance] = useState(false);
  const [hostelAttendance, setHostelAttendance] = useState(false);
  const [hostelCategory, setHostelCategory] = useState(false);

  const [selectedAttendanceType, setSelectedAttendanceType] = useState([]);
  //const [screenType, setScreenType] = useState("swipe");

  let searchParams = queryParam(useQuery());
  let allowOd = context.settingValue("attendance_allow_od_by_staff") == "1";
  let screenType = context.settingValue("mob_staff_att_screen_type");

  const [activeTab, setActiveTab] = useState(
    searchParams?.from ? "marklist" : "attendance"
  );

  const stateField = (fieldName) => {
    return searchParams?.[fieldName] || "";
  };

  const getAttendanceDate = () => {
    let m = stateField("attendance_date");
    if (m && m.length > 7) return momentDate(m, "YYYY-MM-DD");

    let x = context.getStorage("mob_attendance_date");
    return x && x != null ? x : momentDate(new Date(), "YYYY-MM-DD");
  };

  const [attendaceDate, setAttendaceDate] = useState(
    momentDate(new Date(), "YYYY-MM-DD")
  );

  useEffect(() => {
    if (stateField("course") != undefined) {
      //loadAllDatas();
    }
    loadMarkedHostelAttendance();
  }, []);

  const loadAllDatas = () => {
    loadLongAbsenteeData();

    loadMarkedAttendance();
  };

  useEffect(() => {
    if (dataList.length > 0) mergeData();
    else setLoader(false);
  }, [dataList, markedData]);

  const loadMarkedHostelAttendance = () => {
    setSelectedAttendanceType([]);
    setDataList([]);
    setDataView([]);
    const form = new FormData();
    form.append("acyear", context.acyear.name);
    form.append("attendance_date", attendaceDate);
    form.append("staff_id", context.user.id);

    axios.post(ServiceUrl.MOB.LIST_HOSTEL_ATTENDANCE, form).then((res) => {
      if (res["data"].status == "1") {
        context.setLoader(false);
        setHostelAttendance(res["data"].data);
        setHostelCategory(res["data"].category);
      }
      //context.setLoader(false);
    });
  };

  const loadMarkedAttendance = () => {
    context.setLoader(true);
    const form = new FormData();
    form.append("attendance_date", attendaceDate);
    form.append("hour_value", stateField("hour_value"));
    form.append("teacher", stateField("teacher"));
    form.append("subject", stateField("subject"));
    if (stateField("part") != "4") form.append("course", stateField("course"));
    form.append("college_year", stateField("college_year"));
    form.append("academic_year", stateField("academic_year"));
    form.append("semester", stateField("semester"));
    form.append("section", stateField("section"));
    form.append("marked_teacher_id", stateField("marked_teacher_id"));
    form.append("marked_subject", stateField("marked_subject"));
    form.append("entry_type", stateField("entry_type"));

    axios.post(ServiceUrl.MOB.LIST_STUDENTS_ATTENDANCE, form).then((res) => {
      if (res["data"].status == "1") {
        if (res["data"].work_done) {
          let w = res["data"].work_done;
          if (w && w.work_done) setWorkDone(w.work_done);
        }
        setMarkedData(res["data"].data);
        context.setLoader(false);
      }
    });
  };

  const loadData = (e = false) => {
    context.setLoader(true);
    const form = new FormData();

    form.append("attendance_date", e[0].date);
    form.append("attendance_type", e[0].attendance_type);
    form.append("floor", e[0].floor);
    axios
      .post(ServiceUrl.MOB.SEARCH_HOSTEL_STUDENT_FOR_ATTENDANCE, form)
      .then((res) => {
        if (res["data"].status == "1") {
          let d = res["data"].data;
          if (res.data.time_slots) setTimeSlots(res.data.time_slots);
          let m = groupByMultiple(d, function (obj) {
            return [obj.room_no];
          });
          setDataList(d);
          setDataView(m);
        } else {
          Toast.show({
            content: res["data"].message || "Error",
            position: "top",
          });
          context.setLoader(false);
        }
      });
  };

  const loadLongAbsenteeData = () => {
    context.setLoader(true);
    const form = new FormData();
    form.append("course", stateField("course"));
    form.append("semester", stateField("semester"));
    form.append("section", stateField("section"));
    form.append("college_year", stateField("college_year"));
    form.append("academic_year", stateField("academic_year"));
    form.append("attendance_date", attendaceDate);

    axios.post(ServiceUrl.MOB.LIST_LONG_ABSENTEE, form).then((res) => {
      if (res["data"].status == "1") {
        let d = res["data"].data;

        setLongAbsentee(d);
      } else {
        Toast.show({
          content: res["data"].message || "Error",
          position: "top",
        });
        context.setLoader(false);
      }
    });
  };

  const checkMarkedAttendaceStatus = (item) => {
    let m = markedData.find(
      (obj) => obj.student_uuid == item.uuid && obj.course == item.course
      //obj.day_value == item.day_value &&
      //obj.hour_value == item.hour_value &&
      //obj.semester == item.semester &&
      //obj.subject == item.subject &&
      //obj.teacher == item.teacher
    );
    return m;
  };

  const checkLongAbsentee = (uuid) => {
    let x = longAbsentee.findIndex((obj) => obj.student_uuid == uuid);
    return x > -1 ? true : false;
  };

  const mergeData = () => {
    context.setLoader(true);
    let d = dataList;
    let x = [];
    d.map((item, i) => {
      let m = checkMarkedAttendaceStatus(item);
      let la = checkLongAbsentee(item.uuid);
      x.push({
        id: m?.id || "",
        course: item.course,
        section: lowerCase(item.section),
        academic_year: item.batch,
        semester: item.semester,
        day_value: m?.day_value || "",
        hour_value: m?.hour_value || "",
        student_uuid: item.uuid,
        leave_type: la ? "la" : m?.leave_type || "p",
        subject: stateField("subject"),
        teacher: stateField("teacher"),
        room_id: item.room_no,
        remarks: item.remarks,
      });
    });
    setMarkedStudents(x);
    context.setLoader(false);
  };

  const confirmClick = () => {
    Dialog.confirm({
      content: "Do you want to Save Attendance ?",
      confirmText: "Yes",
      cancelText: "No",
      onConfirm: () => saveAttendance(),
    });
  };
  /*
  if (stateField("id") === undefined) {
    return <Redirect to={"/mob/app"} />;
  }
*/
  const absendClick = (item, ltype = "a") => {
    let m = [...markedStudents];

    let index = m.findIndex((obj) => obj.student_uuid == item.uuid);

    if (index > -1) {
      let lt = m[index]["leave_type"];
      if (lt == ltype) m[index]["leave_type"] = "";
      else m[index]["leave_type"] = ltype;

      m[index]["remarks"] = item.reason;
      setMarkedStudents(m);
    }
  };

  const checkStudentMarked = (item) => {
    let m = markedStudents;
    let index = m.findIndex((obj) => obj.student_uuid == item.uuid);
    return index > -1 && m[index]["leave_type"];
  };

  const markedCount = (ltype) => {
    let m = markedStudents.filter((item) => item.leave_type == ltype);
    return m.length;
  };

  const saveAttendance = () => {
    context.setLoader(true);
    let clist = [];
    const form = new FormData();
    form.append("students", JSON.stringify(markedStudents));
    form.append("attendance_date", attendaceDate);
    form.append("day_value", stateField("day_value"));
    form.append("hour_value", stateField("hour_value"));
    form.append("teacher", context.user.id);
    form.append("subject", stateField("subject"));
    form.append("course", stateField("course"));
    form.append("college_year", context.user.college_year);
    form.append("acyear", context.acyear.name);
    form.append("semester", stateField("semester"));
    form.append("section", stateField("section"));
    form.append("entry_type", stateField("entry_type"));
    form.append("hostel_id", selectedAttendanceType[0].hostel_id);
    form.append("category_id", selectedAttendanceType[0].attendance_type);
    form.append("floor_id", selectedAttendanceType[0].floor);

    axios
      .post(ServiceUrl.MOB.SAVE_HOSTEL_STUDENT_ATTENDANCE, form)
      .then((res) => {
        if (res["data"].status == "1") {
          Toast.show({
            icon: "success",
            content: res["data"].message || "Success",
          });
          loadMarkedHostelAttendance();
          if (stateField("hour_value").length > 1) {
            navigate("/staff/app");
          }
        } else {
          Toast.show({
            icon: "error",
            content: res["data"].message || "Error",
          });
        }
        context.setLoader(false);
      });
  };

  const swipeActionList = (item) => {
    if (checkLongAbsentee(item.uuid)) return [];

    if (
      !context.allowedAccess("mob_student_attendance", "action_update") &&
      markedData.length > 0
    )
      return [];

    let rv = [];

    if (allowOd)
      rv.push({
        key: "od",
        text: "OD",
        color: "primary",
        onClick: () => absendClick(item, "od"),
      });

    if (
      context.allowedAccess("mob_student_attendance_leave", "action_create")
    ) {
      rv.push({
        key: "l",
        text: "L",
        color: "light",
        onClick: () => absendClick(item, "l"),
      });
    }

    rv.push({
      key: "ab",
      text: "AB",
      color: "danger",
      onClick: () => absendClick(item),
    });

    if (checkStudentMarked(item) != "p")
      rv.push({
        key: "p",
        text: "P",
        color: "success",
        onClick: () => absendClick(item, "p"),
      });

    return rv;
  };

  const getExtraButton = (item) => {
    if (checkLongAbsentee(item.uuid)) return [];

    if (
      !context.allowedAccess("mob_student_attendance", "action_update") &&
      markedData.length > 0
    )
      return [];

    let sta = checkStudentMarked(item);

    let rv = [];
    rv.push(
      <Button
        size="md  me-2"
        variant={sta == "p" ? "success" : "light"}
        onClick={() => absendClick(item, "p")}
      >
        P
      </Button>
    );
    rv.push(
      <Button
        size="md"
        variant={sta == "a" ? "danger" : "light"}
        onClick={() => absendClick(item)}
      >
        A
      </Button>
    );
    return rv;
  };

  const handleDeleteClick = () => {
    Dialog.confirm({
      content: "Do you want to Delete ?",
      confirmText: "Yes",
      cancelText: "No",
      onConfirm: () => {
        confirmDelete();
      },
    });
  };

  const confirmDelete = () => {
    context.setLoader(true);
    let d = markedData[0];
    let x = [];
    let m = groupByMultiple(dataList, function (obj) {
      return [obj.course, lowerCase(obj.section)];
    });

    m.map((item) =>
      x.push({ course: item[0].course, section: item[0].section })
    );
    const form = new FormData();
    form.append("academic_year", d.academic_year);
    form.append("attendance_date", d.attendance_date);

    form.append("college_year", d.college_year);
    form.append("course", JSON.stringify(x));
    form.append("day_value", stateField("day_value"));
    form.append("hour_value", stateField("hour_value"));
    form.append("semester", stateField("semester"));
    form.append("section", stateField("section"));
    form.append("teacher", stateField("teacher"));
    form.append("subject", stateField("subject"));
    form.append("entry_type", stateField("entry_type"));
    /*form.append("day_value", d.day_value);
    form.append("subject", d.subject);
    form.append("hour_value", d.hour_value);
    form.append("semester", d.semester);
    form.append("section", d.section);
    form.append("teacher", d.teacher);*/
    //
    axios.post(ServiceUrl.MOB.DELETE_TIMETABLE, form).then((res) => {
      if (res["data"].status == "1") {
        Toast.show({
          icon: "success",
          content: res["data"].message || "Success",
        });
        setMarkedStudents([]);
        loadMarkedAttendance();
        setMarkedData([]);
      } else {
        Toast.show({
          icon: "error",
          content: res["data"].message || "Error",
        });
      }
      context.setLoader(false);
    });
  };

  const listSelectedHourValues = () => {
    let h = stateField("hour_value");
    //if (h.length == 1) return "H" + h;

    //h = JSON.parse(h);

    return h;
  };

  useEffect(() => {
    if (timeSlots && timeSlots.length > 0) {
      checkTimeExist();
      const interval = setInterval(() => {
        checkTimeExist();
      }, 5000);
      return () => clearInterval(interval);
    } else {
      setAllowAttendance(true);
    }
  }, [timeSlots]);

  const checkTimeExist = () => {
    let rv = true;
    let currentHour = stateField("hour_value");
    if (timeSlots && timeSlots.length > 0) {
      if (currentHour) {
        let s = timeSlots.find((item) => item.hour_value == currentHour);
        if (s) {
          var now = new Date();
          let start_time = false;
          let end_time = false;
          // to check attendance start time
          if (s && s.att_start_time) {
            start_time = new Date(
              momentDate(new Date(), "YYYY-MM-DD") + " " + s.att_start_time
            );
          }
          if (s && s.att_end_time) {
            end_time = new Date(
              momentDate(new Date(), "YYYY-MM-DD") + " " + s.att_end_time
            );
          }
          if (
            now.getTime() < start_time.getTime() ||
            now.getTime() > end_time.getTime()
          ) {
            rv = false;
          }
        }
      }
    }
    setAllowAttendance(rv);
  };

  const attendanceTimeMessage = () => {
    let rv = "";
    let currentHour = stateField("hour_value");
    if (timeSlots && timeSlots.length > 0) {
      if (currentHour) {
        let s = timeSlots.find((item) => item.hour_value == currentHour);
        if (s) {
          var now = new Date();
          let start_time = false;
          let end_time = false;
          // to check attendance start time
          if (s && s.att_start_time) {
            start_time = new Date(
              momentDate(new Date(), "YYYY-MM-DD") + " " + s.att_start_time
            );
          }
          if (s && s.att_end_time) {
            end_time = new Date(
              momentDate(new Date(), "YYYY-MM-DD") + " " + s.att_end_time
            );
          }
          if (now.getTime() < start_time.getTime()) {
            rv = `Attendance will begin at ${momentDate(
              start_time,
              "hh:mm A"
            )}`;
          }
          if (now.getTime() > end_time.getTime()) {
            rv = `Attendance closed at ${momentDate(end_time, "hh:mm A")}`;
          }
        }
      }
    }
    return rv;
  };

  const linkClick = (toUrl, val) => {
    navigate(toUrl + "?category=" + val);
  };
  return (
    <>
      <Header
        backAction={true}
        title={
          <>
            Attendance Entry{" "}
            <span style={{ fontSize: "12px" }}>
              {momentDate(attendaceDate, "DD-MMM-YYYY")}
            </span>
          </>
        }
        rightActions={
          markedData.length > 0 ? (
            context.allowedAccess(
              "mob_delete_marked_attendance",
              "action_delete"
            ) ? (
              <li>
                <a
                  style={{ textDecoration: "underline" }}
                  className="text-primary"
                  onClick={(e) => handleDeleteClick()}
                >
                  Delete
                </a>
              </li>
            ) : (
              []
            )
          ) : (
            []
          )
        }
      />

      <div className="page-content-wrapper">
        <div className="container py-3">
          <Tabs
            className="bg-white"
            activeKey={activeTab}
            onChange={(k) => setActiveTab(k)}
          >
            <Tabs.Tab title="Attendance" key="attendance" />
            <Tabs.Tab title="Marked List" key="marklist" />
          </Tabs>
        </div>
        {activeTab == "attendance" && (
          <div className="container py-3">
            {hostelCategory && hostelCategory.length > 0 && (
              <div className="mt-2">
                Attendance Data - {momentDate(attendaceDate, "DD-MMM-YYYY")}
                <List>
                  {hostelCategory.map((item) => (
                    <List.Item
                      className="ps-3"
                      onClick={(e) =>
                        linkClick(
                          `/staff/app/hostel-att-report/`,
                          item.attendence_id +
                            "&attendance_date=" +
                            attendaceDate +
                            "&floor_id=" +
                            item.id +
                            "&acyear=" +
                            context.acyear.name
                        )
                      }
                    >
                      {item.attendence_name}
                      {" - "} {item.floor_name}
                      <span style={{ float: "right", fontSize: "14px" }}>
                        View Attendance
                      </span>
                    </List.Item>
                  ))}
                </List>
              </div>
            )}

            <div className="mt-2">
              <AttendanceType
                dataParams={searchParams}
                hostelAttendance={hostelAttendance}
                dataSource={selectedAttendanceType}
                context={context}
                onSuccess={(d) => {
                  loadData(d);
                  setSelectedAttendanceType(d);
                  Modal.clear();
                }}
              />
            </div>

            <section className="category-listing px-15 lg-space top-space pt-0 att_page_list">
              <div className="py-1 text-center fw-bold fs-7">
                {/* {stateField("subject_name")} - H-{listSelectedHourValues()} */}
              </div>
              {dataView.map((items, i) => {
                let rooms = selectedAttendanceType[0].room_list.filter(
                  (item) => item.id == items[0].room_no
                );
                return (
                  <>
                    <div
                      className="text-center py-2 text-primary"
                      data-aos="zoom-in"
                    >
                      <b className="fs-6">
                        {/* {rooms[0].room_no}{" "} */}
                        {rooms && rooms.length > 0 && rooms[0].room_no ? (
  <span>{rooms[0].room_no}</span>
) : (
  <span></span>
)}
                        {/* - {yearByBatch(items[0].batch)}-
                      {items[0].degree_name}-{items[0].course_short_name} (
                      {items[0].dept_type == "aided" ? "R" : "SF"}) -
                      {upperCase(items[0].section)} */}
                      </b>
                    </div>
                    {screenType == "swipe" && (
                      <SwipeScreen
                        items={items}
                        checkStudentMarked={(d) => checkStudentMarked(d)}
                        absendClick={(stu, lt) => absendClick(stu, lt)}
                        allowAttendance={allowAttendance}
                        markedData={markedData}
                        longAbsentee={longAbsentee}
                        checkLongAbsentee={checkLongAbsentee}
                      />
                    )}
                    {screenType == "button" && (
                      <ButtonScreen
                        items={items}
                        checkStudentMarked={(d) => checkStudentMarked(d)}
                        absendClick={(stu, lt) => absendClick(stu, lt)}
                        allowAttendance={allowAttendance}
                        markedData={markedData}
                        longAbsentee={longAbsentee}
                        checkLongAbsentee={checkLongAbsentee}
                      />
                    )}
                  </>
                );
              })}
              {/* {context.allowedAccess("mob_staff_workdone", "action_create") && (
                <div className="mt-2">
                  <Form.Control
                    as="textarea"
                    name="work_done_text"
                    className="fw-bold"
                    rows="4"
                    placeholder="Enter your work done here.. (Topics Discussed)"
                    ref={workDoneRef}
                    defaultValue={workDone}
                    onChange={(e) => setWorkDone(e.target.value)}
                  />
                </div>
              )} */}
            </section>
          </div>
        )}

        {activeTab == "marklist" && (
          <MarkedHostelAttendanceReport
            attendance_date={attendaceDate}
            acyear={context.acyear.name}
          />
        )}
      </div>
      {activeTab == "attendance" && (
        <div className="footer-nav-area pt-2 px-3">
          <div className="suha-footer-nav " style={{ height: "42px" }}>
            <div className="row">
              <div className="col-4">
                {allowAttendance ? (
                  <>
                    {!context.allowedAccess(
                      "mob_student_attendance",
                      "action_update"
                    ) && markedData.length > 0 ? null : (
                      <Button
                        variant="primary"
                        className="w-100"
                        onClick={(e) => confirmClick()}
                      >
                        Save
                      </Button>
                    )}
                  </>
                ) : (
                  <>{attendanceTimeMessage()}</>
                )}
              </div>
              <div className="col-8 text-end">
                <Button size="sm" variant="light" style={{ fontSize: "12px" }}>
                  <span className="border-bottom text-danger">AB</span> :
                  <span className="text-danger">{markedCount("a")}</span>
                </Button>

                {/* <Button size="sm" variant="light" style={{ fontSize: "12px" }}>
                <span className="border-bottom text-primary">OD</span>:
                <span className="text-primary">{markedCount("od")}</span>
              </Button> */}
                <Button size="sm" variant="light" style={{ fontSize: "12px" }}>
                  <span className="border-bottom text-primary">LWP</span>:
                  <span className="text-primary">{markedCount("lwp")}</span>
                </Button>
                <Button size="sm" variant="light" style={{ fontSize: "12px" }}>
                  <span className="border-bottom text-dark">L</span>:
                  <span className="text-dark ">{markedCount("l")}</span>
                </Button>
                <Button size="sm" variant="light" style={{ fontSize: "12px" }}>
                  <span className="border-bottom text-success">P</span>:
                  <span className="text-success ">{markedCount("p")}</span>
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default HostelAttendance;
